const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorsliders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11 15V17H21V19H11V21H5V19H3V17H5V15H11ZM7 19H9V17H7V19Z",
    fill: "currentColor",
    style: {
      fill: "currentColor",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9V15H15V13H3V11H15V9H21ZM17 13H19V11H17V13Z",
    fill: "currentColor",
    style: {
      fill: "currentColor",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3V5H21V7H15V9H9V7H3V5H9V3H15ZM11 7H13V5H11V7Z",
    fill: "currentColor",
    style: {
      fill: "currentColor",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorsliders);
export default __webpack_public_path__ + "static/media/Color sliders.2c9736f2fdf5269556ee8632f1478306.svg";
export { ForwardRef as ReactComponent };